<template>
    <div class="mb-4">
        <div class="px-0 mt-3">
            <b-row class="mb-4">
                <b-col cols="12" md="3">
                    <label>{{ $t('Date of Establishment') }} <span class="text-danger">*</span></label>
                </b-col>

                <b-col sm="12" md="9">
                    <date-picker v-model="params.registerDate" :lang="lang_date" input-class="form-control" format="YYYY-MM-DD" value-type="YYYY-MM-DD" @change="onChange('registerDate')"></date-picker>
                    <div v-if="error['registerDate']" class="invalid-feedback d-block mb-3">
                        {{$t(error['registerDate'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-4">
                <b-col xl="4" sm="12">
                    <div class="form-group mb-0">
                        <label>{{ $t('Registered Address (Province)') }} <span class="text-danger">*</span></label>
                        <Select2 v-model="params.registerProvince" :options="provinceOpt" @select="onSelectProvince($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Province")}' class="form-control"/>
                        <div v-if="error['registerProvince']" class="invalid-feedback d-block mb-3">
                            {{$t(error['registerProvince'])}}
                        </div>
                    </div>
                </b-col>
                <b-col xl="4" sm="12">
                    <div class="form-group mb-0">
                        <label>{{ $t('Registered address (city)') }} <span class="text-danger">*</span></label>
                        <Select2 v-model="params.registerCity" :options="cityOpt" @select="onSelectCity($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("City")}' class="form-control"/>
                        <div v-if="error['registerCity']" class="invalid-feedback d-block mb-3">
                            {{$t(error['registerCity'])}}
                        </div>
                    </div>
                </b-col>
                <b-col xl="4" sm="12">
                    <div class="form-group mb-0">
                        <label>{{ $t('Registered Address (District)') }}</label>
                        <Select2 v-model="params.registerArea" :options="districtOpt" @select="onSelectDistrict($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("District")}' class="form-control"/>
                        <div v-if="error['registerArea']" class="invalid-feedback d-block mb-3">
                            {{$t(error['registerArea'])}}
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-4">
                <b-col xl="12">
                    <div class="form-group mb-0">
                        <label>{{ $t('Registered address (full address)') }} <span class="text-danger">*</span></label>
                        <input type="text" name="registerAddress" v-model="params.registerAddress" class="form-control" @keydown="addressCondition($event)" @keyup="onchangeAddress($event)"/>
                        <div v-if="error['registerAddress']" class="invalid-feedback d-block mb-3">
                            {{$t(error['registerAddress'])}}
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col cols="12" md="3">
                    <label>{{ $t('Registered capital (CNY)') }} <span class="text-danger">*</span></label>
                </b-col>

                <b-col sm="12" md="9">
                    <MaskAmount @set-price="changePrice($event)" :bus="registerAmt" ref="registerAmt"></MaskAmount>
                    <div v-if="error['registerAmt']" class="invalid-feedback d-block mb-3">
                        {{$t(error['registerAmt'])}}
                    </div>
                </b-col>
            </b-row>
            
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Select2 from 'v-select2-component';

import NewDocOption from "@/components/Kyc/NewDocOption";
import NewPopupInfo from '@/components/NewPopupInfo.vue';
import CreateAccount from '@/services/CreateAccount';
import MaskAmount from "@/components/Mask/MaskAmount";

import 'vue2-datepicker/locale/zh-cn';
import 'vue2-datepicker/locale/zh-tw';
import 'vue2-datepicker/locale/ja';
import 'vue2-datepicker/locale/en';

export default {
  data() {
    return {
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        showPopup_1:false,
        showPopup_2:false,
        showPopup_3:false,
        lang_date:'en',
        cityOpt:[],
        districtOpt:[],
        provinceOpt:[],
        optional:['registerArea'],
        registerAmt:new Vue(),
        params:{
            registerAmt:'',
            registerProvince:'',
            registerCity:'',
            registerArea:'',
            registerAddress:'',
            registerDate:''
        },
        error:{
            registerAmt:'',
            registerProvince:'',
            registerCity:'',
            registerArea:'',
            registerAddress:'',
            registerDate:''
        }
    }
  },
  components:{
    NewDocOption,
    Select2,
    NewPopupInfo,
    DatePicker,
    MaskAmount
  },
  props:['information','user_no','account_id'],
  methods:{
    changePrice(event){
        this.error.registerAmt = '';
        this.params.registerAmt = event;
    },
    addressCondition($event){
        if($event.keyCode == 13){
            $event.preventDefault();
        }
        this.onChange('registerAddress');
    },
    onchangeAddress($event){
        let msg = $event.target.value.replace("\n", " ");
        $event.target.value = msg;
    },
    onSelectDistrict({id,text}){
        var self = this;
        this.onChange('registerArea');
    },
    onSelectCity({id,text,code}){
        var self = this;
        this.onChange('registerCity');
        if(text){
            this.registerArea="";
        }
        this.getDistrict(code);
    },
    onSelectProvince({id,text,code}){
        var self = this;
        this.onChange('registerProvince');
        self.districtOpt = [];
        if(text){
            this.registerCity = "";
            this.registerArea = "";
        }
        this.getCity(code);
    },
    getDistrict(code){
        this.districtOpt = [];
        CreateAccount.getDistrict({"city_id":code}).then(response => {
            const data = response.data.data;
            data.forEach(item => {
                this.districtOpt.push({"id":item.value,"text":item.text,"code":item.code});
            });
        }).catch(err => {
            this.checkError(err);
        });
    },
    getCity(code){
        this.cityOpt = [];
        CreateAccount.getCity({"province_id":code}).then(response => {
            const data = response.data.data;
            data.forEach(item => {
                this.cityOpt.push({"id":item.value,"text":item.text,"code":item.code});
            });
        }).catch(err => {
            this.checkError(err);
        });
    },
    onChange(name){
        this.error[name]="";
    },
    validate(){
        let success = true;
        let self = this;
        Object.keys(this.params).forEach(function(key) {
            if(!self.params[key] && !self.optional.includes(key)){
                self.error[key]="can not be blank.";
                success = false;
            }
        });

        return success;
    },
    togglePopup(index){
        this['showPopup_'+index]=!this['showPopup_'+index];
    },
    selectedDocument(data){
        this.params.legalIdType = data;
        this.error.legalIdType = "";
    },
    captureFile($event,key) {
        this.params[key]=$event;
        this.error[key]="";
    },
    removeImage($event,key){
        this.error[key]="";
    },
    doEscapeMarkup(markup){
        return markup;
    }
  },
  mounted(){
    let self = this;
    this.$nextTick(() => {
    
        CreateAccount.getProvince({"country":"CHN"}).then(response => {
            const data = response.data.data;
            this.provinceOpt = [];
            data.forEach(item => {
                this.provinceOpt.push({"id":item.value,"text":item.text,"code":item.id});    
            });
            
            if(this.information){
                Object.keys(this.params).forEach(function(key) {
                    if(typeof self.params[key]!=="undefined" && self.information[key]){
                        self.params[key]=self.information[key];
                    }
                });

                if(self.params.registerAmt){
                    this.$refs['registerAmt'].init(self.params.registerAmt);
                }
                
                if(this.params.registerProvince){
                    let data_province = this.params.registerProvince.split("_");
                    this.getCity(data_province[0]);
                }
                
                if(this.params.registerCity){
                    let data_city = this.params.registerCity.split("_");
                    this.getDistrict(data_city[0]);
                }
            }

            if(this.user_no){
                this.userNo = this.user_no;
                this.accountId = this.account_id;
            }

        }).catch(err => {
            this.checkError(err);
        });
    });
  }
}
</script>

<style>
.form-group{
    margin-bottom: 0 !important;
}
</style>